
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/buying/auction-methods",
      function () {
        return require("private-next-pages/content/buying/auction-methods.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/buying/auction-methods"])
      });
    }
  